module.exports = [
    // get user permission
    {
        url: '/api/permission',
        type: 'get',
        response: () => {
            const permissionData = [
                {sysCode:'TCvue',resCode:'resCode1'},
                {sysCode:'TCvue',resCode:'resCode2'},
                {sysCode:'TCvue',resCode:'resCode4'},
            ]
            if (!permissionData) {
                return {
                    code: 50008,
                    message: '获取失败'
                }
            }
            return {
                code: 0,
                message: 'success',
                data: permissionData
            }
        }
    }
]
